export default "__VITE_ASSET__Cgx9hPER__"